import { CheckIsFailureMutationStatusUseCase } from './CheckIsFailureMutationStatusUseCase'

export const checkIsFailureMutationStatusUseCase =
  new CheckIsFailureMutationStatusUseCase().execute
